import React from "react";
import { Link } from "react-router-dom";

const HeroSection = () => {
  return (
    <section className="hero-section d-flex align-items-center justify-content-center">
      <div className="container text-center text-white mx-3">
        <h1 className="fw-bold mb-3" style={{color:"white",fontSize:"45px"}}>
          Get the Right Guidance and Build <br />
          Strong Values with Sanatan Wisdom.
        </h1>
        <p className="mb-4" style={{color:"#fff !important",fontSize:"25px"}}><small>
          Build your future with confidence. Our mentors guide you toward the right path of knowledge, values, and Sanatan wisdom—tailored to your goals and life journey.</small>
        </p>
        <Link to="/contact" className="btn btn-danger btn-lg">
          Contact Us
        </Link>
      </div>
    </section>
  );
};

export default HeroSection;
